import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { FABRIC_TYPE_CONFIG_URL } from "../../../../api/api_routing_urls";
// import useAuth from "../../../../authentication/hooks/useAuth";
// import useAxiosPrivate from "../../../../authentication/hooks/useAxiosPrivate";
import axios from "../../../../api/axios";
import Dashboard from "../../../../common/dashboard-components/dashboard.component";
import MasterConfigHeaderWithoutDeleteWrapper from "../../../../common/master-config/MasterConfigHeaderWithoutDeleteWrapper";
import GenericModal from "../../../../reusable-components/modals/GenericModal";
import showToast from "../../../../utilities/notification/NotificationModal";

import AddFabricTypeForm from "./addFabricTypeForm.component";
import FabricTypeList from "./fabricTypeList.component";

const FabricTypeConfig = () => {
  // const { auth } = useAuth();
  const [fabricTypeList, setFabricTypeList] = useState([]);
  // const axiosPrivate = useAxiosPrivate();
  const [showAddForm, setShowAddForm] = useState(false);
  const [editFabricTypeDetails, setEditFabricTypeDetails] = useState({});
  const isEdit = Object.keys(editFabricTypeDetails).length > 0 ? true : false;

  const getFabricTypeList = async () => {
    try {
      const response = await axios.get(FABRIC_TYPE_CONFIG_URL);
      // console.log("Fabric Type List", { response });
      response.status === 200 &&
        setFabricTypeList(response.data.fabricTypeList);
      response.status === 202 &&
        showToast("No fabric type found in the system.", "error");
    } catch (error) {
      console.error("getFabricTypeList", error);
      if (!error?.response) {
        showToast("No Server Response");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided.", "error");
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact the administrator.",
          "error"
        );
      }
    }
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      getFabricTypeList();
      setEditFabricTypeDetails({});
    }
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    // <Dashboard sidebarType={auth.rolename}>
    <Dashboard>
      <ToastContainer />
      <MasterConfigHeaderWithoutDeleteWrapper
        headerTitle={"Fabric Type"}
        setShowAddForm={setShowAddForm}
      />
      <GenericModal
        open={showAddForm}
        setOpen={setShowAddForm}
        title={` ${
          isEdit ? "Update Fabric Type Details" : "Add Fabric Type Details"
        }`}
        isAdd={true}
        clearData={setEditFabricTypeDetails}
      >
        <AddFabricTypeForm
          getFabricTypeList={getFabricTypeList}
          editFabricTypeDetails={editFabricTypeDetails}
          setEditFabricTypeDetails={setEditFabricTypeDetails}
          setShowAddForm={setShowAddForm}
        />
      </GenericModal>
      <div className="grid grid-cols-1">
        <FabricTypeList
          fabricTypeList={fabricTypeList}
          getFabricTypeList={getFabricTypeList}
          setEditFabricTypeDetails={setEditFabricTypeDetails}
          setShowAddForm={setShowAddForm}
        />
      </div>
    </Dashboard>
  );
};

export default FabricTypeConfig;
